import { useCallback, useEffect, useMemo, useState } from 'react';
import userInfo from 'hub-http/userInfo';
// Removes g8 prefix @see https://hubspot.slack.com/archives/C0CHG9FGE/p1718996632412339
import { gate as getV3Gate } from 'hub-http/gates';
const INITIAL_STATE = {
  data: undefined,
  error: undefined,
  loading: false
};
const requiredScopes = ['campaigns-access', 'campaigns-write', 'content-remix-access', 'content-remix-read'];
export default function useUserInfo(userInfoProps) {
  const [userInfoState, setUserInfoState] = useState(INITIAL_STATE);
  const isUngatedForPostPublishModal = useCallback(() => {
    var _userInfoState$data$u;
    return Boolean(userInfoState.data && userInfoState.data.gates.includes(getV3Gate('MO:StudioActivation:StudioPostPublishModal')) && userInfoState.data.gates.includes(getV3Gate('GoToMarketingStudio')) && ((_userInfoState$data$u = userInfoState.data.user) === null || _userInfoState$data$u === void 0 ? void 0 : _userInfoState$data$u.scopes) && requiredScopes.every(scope => userInfoState.data.user.scopes.includes(scope)));
  }, [userInfoState.data]);
  const isUngatedForAssetReportingCard = useCallback(() => {
    var _userInfoState$data$u2;
    return Boolean(userInfoState.data && userInfoState.data.gates.includes(getV3Gate('MO:StudioActivation:AssetReportingCard')) && userInfoState.data.gates.includes(getV3Gate('GoToMarketingStudio')) && ((_userInfoState$data$u2 = userInfoState.data.user) === null || _userInfoState$data$u2 === void 0 ? void 0 : _userInfoState$data$u2.scopes) && requiredScopes.every(scope => userInfoState.data.user.scopes.includes(scope)));
  }, [userInfoState.data]);
  const isUngatedForBetaAnnouncementModal = useCallback(() => {
    var _userInfoState$data$u3;
    return Boolean(userInfoState.data &&
    // We only show the beta announcement for users that haven't joined the beta (still gated for GoToMarketingStudio)
    !userInfoState.data.gates.includes(getV3Gate('GoToMarketingStudio')) && userInfoState.data.gates.includes(getV3Gate('MO:StudioActivation:BetaAnnouncementNudge')) && ((_userInfoState$data$u3 = userInfoState.data.user) === null || _userInfoState$data$u3 === void 0 ? void 0 : _userInfoState$data$u3.scopes) &&
    // Since we already check the campaign-access scope we don't need to check if it is pro+ user
    userInfoState.data.user.scopes.includes('campaigns-access'));
  }, [userInfoState.data]);
  const isUngatedForStudioOverview = useCallback(() => {
    var _userInfoState$data$u4;
    return Boolean(userInfoState.data && userInfoState.data.gates.includes(getV3Gate('MO:StudioActivation:StudioOverview')) && userInfoState.data.gates.includes(getV3Gate('GoToMarketingStudio')) && ((_userInfoState$data$u4 = userInfoState.data.user) === null || _userInfoState$data$u4 === void 0 ? void 0 : _userInfoState$data$u4.scopes) && requiredScopes.every(scope => userInfoState.data.user.scopes.includes(scope)));
  }, [userInfoState.data]);
  useEffect(() => {
    setUserInfoState(Object.assign({}, INITIAL_STATE, {
      loading: true
    }));
    userInfo(userInfoProps).then(data => setUserInfoState(Object.assign({}, INITIAL_STATE, {
      data
    }))).catch(error => setUserInfoState(Object.assign({}, INITIAL_STATE, {
      error
    })));
  }, [userInfoProps]);
  return useMemo(() => Object.assign({}, userInfoState, {
    isUngatedForPostPublishModal,
    isUngatedForAssetReportingCard,
    isUngatedForStudioOverview,
    isUngatedForBetaAnnouncementModal
  }), [isUngatedForPostPublishModal, isUngatedForAssetReportingCard, isUngatedForStudioOverview, isUngatedForBetaAnnouncementModal, userInfoState]);
}